module.exports = __webpack_public_path__ + "assets/img/06d1cf211fffdabafd17979e63cd69c7.png";